module.exports = {"id":"s5-q1","text":"Do you have an email address?","multiselect":false,"options":[{"id":"s5-q1-a1","text":"Yes","next":"s5-q2","capability":2,"access":2,"focusarea":[0,3,0,0,5]},{"id":"s5-q1-a2","text":"No","next":"s6-q1","capability":-3,"access":-2}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dlrq/questions/s5-q1.json
// module id = 921
// module chunks = 32